import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined"
import DoNotDisturb from "@mui/icons-material/DoNotDisturb"
import CancelOutlined from "@mui/icons-material/CancelOutlined"
import DoNotDisturbOnOutlined from "@mui/icons-material/DoNotDisturbOnOutlined"

import { useTheme } from "@mui/material"

export const useLegendData = () => {
  const theme = useTheme()

  const eventColorData = [
    { iconColor: theme.palette.legend.school, label: "School session" },
    { iconColor: theme.palette.legend.partnership, label: "Partnership session" },
    { iconColor: theme.palette.legend.family, label: "Smarten Up / Family session" },
    { iconColor: theme.palette.legend.interview, label: "Interview" },
  ]

  const sessionStatusData = [
    { Icon: DoNotDisturb, iconColor: theme.palette.legend.noShow, label: "No show (no students attended the session)" },
    {
      Icon: CancelOutlined,
      iconColor: theme.palette.legend.canceled,
      label: "Canceled (session canceled by agreement)",
    },
    {
      Icon: DoNotDisturbOnOutlined,
      iconColor: theme.palette.legend.pending,
      label: "Pending (session is scheduled but has not occurred yet)",
    },
    { Icon: CheckCircleOutlined, iconColor: theme.palette.legend.finished, label: "Finished (session occurred)" },
  ]

  return { eventColorData, sessionStatusData }
}
